import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "video-item" }
const _hoisted_2 = { class: "video-item-title" }

import {useStore} from '../store';
import {Video} from '../types';


export default /*@__PURE__*/_defineComponent({
  __name: 'VideoItem',
  props: {
    video: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("figure", _hoisted_1, [
    _createElementVNode("a", {
      href: "#",
      class: "video-item-thumb",
      style: _normalizeStyle({'background-image': `url(${_ctx.video.thumbnail})`}),
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(store).setPlayVideo(_ctx.video)), ["prevent"]))
    }, null, 4 /* STYLE */),
    _createElementVNode("figcaption", _hoisted_2, _toDisplayString(_ctx.video.title), 1 /* TEXT */)
  ]))
}
}

})